import styled, { css } from 'styled-components';
import { Box, AvatarStyled, Button } from '@bechtel/gds';

export const WeldAssignedStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  px: { sm: '550' },
  pt: { sm: '500' },
  pb: { sm: '600' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    button:disabled {
      opacity: 1;
      & > :last-child {
        opacity: 0;
      }
    }
  `};
`;
export const CrewIconStyled = styled(AvatarStyled)`
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.blue[800]};
    border: 1px solid ${theme.colors.bechtel.blue[700]};
  `};
`;

export const AssignFooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
  `}
`;
